import React from 'react';
import { PageTransition } from '../components/PageTransition';
export function TermsOfServicePage() {
  return <PageTransition data-id="element-878" data-mp="19y3pyh2070rc">
      <div className="pt-32 pb-24 min-h-screen bg-dark-700" data-id="element-879" data-mp="19xlkcttgba6r">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-880" data-mp="14xfyju9v4hwl">
          <div className="mb-12" data-id="element-881" data-mp="14ztwqbzuaa8d">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-882" data-mp="10x5jzt808j64">
              Terms of Service
            </h1>
            <div className="w-24 h-1 bg-gold-500 rounded-full mb-6" data-id="element-883" data-mp="vyvn9e6mtaie"></div>
            <p className="text-white/60" data-id="element-884" data-mp="r5jca6uvl284">Last updated: March 2026</p>
          </div>

          <div className="prose prose-invert prose-gold max-w-none space-y-8 text-white/80" data-id="element-885" data-mp="m6y8jxgf00ex">
            <section data-id="element-886" data-mp="h8wszmi76j87">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-887" data-mp="h9fzm72edl6x">
                1. Acceptance of Terms
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-888" data-mp="d8w2h3htqhks">
                By accessing and using the 3 Doves Podcast website and its
                associated services, you agree to be bound by these Terms of
                Service. If you do not agree with any part of these terms,
                please do not use our website or services.
              </p>
            </section>

            <section data-id="element-889" data-mp="3v2au1y93qbpt">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-890" data-mp="3uyn0iz3nppb3">
                2. Use of Content
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-891" data-mp="qmrjwx6h5so5">
                All content provided on the 3 Doves Podcast website, including
                audio episodes, text, graphics, logos, and images, is the
                property of 3 Doves Podcast or its content creators and is
                protected by copyright laws.
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-892" data-mp="mjlhy1qeannh">
                <li data-id="element-893" data-mp="32bj25cz2k98a">
                  You may listen to, download, and share our podcast episodes
                  for personal, non-commercial use.
                </li>
                <li data-id="element-894" data-mp="378soukv2q6sf">
                  You may not modify, reproduce, or distribute our content for
                  commercial purposes without explicit written permission.
                </li>
                <li data-id="element-895" data-mp="17y6ijsduluop">
                  When sharing our content, proper attribution to 3 Doves
                  Podcast must be provided.
                </li>
              </ul>
            </section>

            <section data-id="element-896" data-mp="z1pfzdjjv54k">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-897" data-mp="u45ubskivq2l">
                3. User Conduct
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-898" data-mp="p4aydalw4aao">
                We strive to build a community based on honest faith and mutual
                respect. When interacting with our website, social media
                channels, or community features, you agree to:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-899" data-mp="2ekk6v5wg1j8o">
                <li data-id="element-900" data-mp="2ehxzp7dgt5qz">
                  Communicate respectfully and refrain from using abusive,
                  harassing, or discriminatory language.
                </li>
                <li data-id="element-901" data-mp="3sg20fv9u8gcz">
                  Not post spam, promotional material, or malicious links.
                </li>
                <li data-id="element-902" data-mp="17wmn83pmtsn">
                  Respect the privacy and stories of our guests and other
                  community members.
                </li>
              </ul>
            </section>

            <section data-id="element-903" data-mp="a4f9q3p9fnhb">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-904" data-mp="39hg0wktyyxb6">
                4. Donations and Support
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-905" data-mp="3ehkfg5bbhhyr">
                Any donations made to 3 Doves Podcast or our associated outreach
                programs are voluntary. We are committed to using all
                contributions responsibly to further our mission and support
                those in need. All donation transactions are processed securely
                through trusted third-party providers.
              </p>
            </section>

            <section data-id="element-906" data-mp="12st6yh8iyfrt">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-907" data-mp="119b3c68iban4">
                5. Disclaimer of Warranties
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-908" data-mp="wcazm1z4qjz6">
                The content provided by 3 Doves Podcast is for informational,
                spiritual, and entertainment purposes. While we share real
                stories of faith and transformation, our content should not be
                considered a substitute for professional mental health, medical,
                or legal advice. We make no warranties regarding the accuracy or
                completeness of the information shared.
              </p>
            </section>

            <section data-id="element-909" data-mp="1ozf5e961r2c0">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-910" data-mp="1oz5g6nstsz7d">
                6. Changes to Terms
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-911" data-mp="22zpyliutwt0c">
                We reserve the right to modify these Terms of Service at any
                time. Any changes will be effective immediately upon posting to
                this page. Your continued use of the website following the
                posting of changes constitutes your acceptance of those changes.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageTransition>;
}